// extracted by mini-css-extract-plugin
export default {"skeleton__head":"styles_skeleton__head__qzZx8","skeleton__column":"styles_skeleton__column__gMgnN","table__skeleton":"styles_table__skeleton__0WOJy"};